import { getIntl, getLocale } from '@umijs/max';
import { List, Modal, Typography } from 'antd';

const { Title } = Typography;

export interface ValidateDataType {
  validations: AuthValidationMessage[] | ValidationOmsLabelAddress | ValidationOMSMessage;
  message?: string;
  status?: string;
}
type AuthValidationMessage = {
  message: string;
  data?: any;
};

export type ValidationOMSMessage = Record<string, string[]>;

export type ValidationOmsLabelAddress = {
  address_validate: LabelAddressValidate;
};
type LabelAddressValidate = {
  warning: string;
  recommend_addresses: LabelRecommendAddress[];
};

export type LabelRecommendAddress = {
  city: string;
  postal_code: string;
  country_code: string;
  suburb: string | null;
};

const ValidateWarning = (data: ValidateDataType) => {
  const intl = getIntl(getLocale());
  const showOMSMessage = (validations: ValidationOMSMessage) => {
    return Object.keys(validations).map((key) => {
      return (
        <List
          split={false}
          size="small"
          dataSource={validations[key]}
          renderItem={(item: string, indexKey) => (
            <List.Item>
              <Title level={3}>
                {indexKey + 1}. {item}
              </Title>
            </List.Item>
          )}
        />
      );
    });
  };

  const showOMSLabelAddressMessage = (validations: ValidationOmsLabelAddress) => {
    return (
      <List
        split={false}
        size="small"
        header={<div>{intl.formatMessage({ id: 'message.validations.recommend_address' })}</div>}
        dataSource={validations.address_validate.recommend_addresses}
        renderItem={(item: LabelRecommendAddress, index: number) => (
          <List.Item>
            {index + 1}.{' '}
            <span style={{ padding: 10 }}>
              {intl.formatMessage({ id: 'label.country' })}: {item.country_code}
            </span>
            <span style={{ padding: 10 }}>
              {intl.formatMessage({ id: 'label.postal' })}: {item.postal_code}
            </span>
            <span style={{ padding: 10 }}>
              {intl.formatMessage({ id: 'label.city' })}: {item.city}
            </span>
            {/* <span style={{ padding: 10 }}>Suburb: {item.suburb}</span> */}
          </List.Item>
        )}
      />
    );
  };

  const content = (validations: AuthValidationMessage[]) => (
    <List
      split={false}
      size="small"
      dataSource={validations}
      renderItem={(item: { message: string }, index: number) => (
        <List.Item>
          <Title level={3}>
            {index + 1}. {item.message}
          </Title>
        </List.Item>
      )}
    />
  );

  const showContent = (
    validations: AuthValidationMessage[] | ValidationOMSMessage | ValidationOmsLabelAddress,
  ) => {
    if (Array.isArray(validations)) {
      return content(validations as AuthValidationMessage[]);
    }
    if (validations.address_validate) {
      return showOMSLabelAddressMessage(validations as ValidationOmsLabelAddress);
    }
    return showOMSMessage(validations as ValidationOMSMessage);
  };

  const showTitle = (data: any) => {
    if (data.validations) {
      if (data.validations.address_validate) {
        return intl.formatMessage({ id: 'message.validations.address_validate' });
      }
      return intl.formatMessage({ id: 'message.warning' });
    }

    return data.message ? data.message : data?.status;
  };

  Modal.warning({
    title: showTitle(data),
    content: showContent(data.validations),
    width: 720,
  });
};

export default ValidateWarning;
